import { Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";

import { FormProvider, useForm } from "react-hook-form";
import axiosClient from "../../../../../../lib/axios";
import ImageWithEditButton from "../../../../../../components/ImageWithEditButton";
import { TOpenModal } from "..";

export default function DialogCriacaoEditBancos({
  open,
  handleClose,
  defaultValue
}: DialogCriacaoEditBancosProps) {

  const queryClient = useQueryClient();

  const methods = useForm<TFormBancos>()
  const { register, handleSubmit, setValue, formState: { errors } } = methods;

  const [imagemPreview, setImagemPreview] = useState<string | null>(null)
  
  const isEdit = useMemo(() => Boolean(defaultValue), [defaultValue])
  const valoresIniciais = useMemo(() => defaultValue?.defaultValue ? defaultValue?.defaultValue : null, [defaultValue])

  //Querys e mutations
  const { mutate: criarBanco, isLoading: isLoadingCriarBanco } = useMutation({
    mutationKey: 'cadastrar-banco',
    mutationFn: (inputs: any) => axiosClient.post("financeiro/configuracoes/cadastrar-banco", inputs, {
      headers: {
        'Content-Type': 'multipart/form-data'
    },
    }),
    onError: (error) => {
      console.error(error)
      enqueueSnackbar('Erro ao cadastrar banco!', { variant: 'error' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["pesquisar-bancos"])
      handleClose()
      enqueueSnackbar('Cadastro do banco realizada com sucesso!', { variant: 'success' });
    }
  })

  const { mutate: atualizarBanco, isLoading: isLoadingAttBanco } = useMutation({
    mutationKey: 'atualizar-banco',
    mutationFn: (inputs: any) => axiosClient.post(`financeiro/configuracoes/atualizar-banco/${valoresIniciais?.id}`, inputs, {
      headers: {
        'Content-Type': 'multipart/form-data'
    },
    }
    ),
    onError: (error) => {
      console.error(error)
      enqueueSnackbar('Erro ao atualizar banco!', { variant: 'error' });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["pesquisar-bancos"])
      handleClose()
      enqueueSnackbar('Atualização do banco realizada com sucesso!', { variant: 'success' });
    }
  })
  //
  //Funções manipuladoras
  const handleChangeInput = useCallback((prop: keyof TFormBancos, value: string | FileList | null) => {
    if (prop === "logo_imagem" && typeof value !== 'string') {
      const novoArquivo = value && value[0];
      if (novoArquivo){
        setImagemPreview(URL.createObjectURL(novoArquivo))
      }
      setValue('logo_imagem', novoArquivo, { shouldValidate: !isEdit ? true : false })
    } 
  }, [])

  const onSubmit = (data: TFormBancos) => {
    if (isEdit) {
      atualizarBanco(data)
    }
    if (!isEdit) {
      criarBanco(data)
    }
  }
  //
  //Valores Importantes
  useMemo(() => {
    if (valoresIniciais?.logo_imagem) {
    setImagemPreview(`${valoresIniciais.logo_imagem}`)
    setValue('logo_imagem', null)
    }
  }, [valoresIniciais?.logo_imagem])

  //
  return (
    <FormProvider {...methods}>
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {`${!isEdit ? "Adicionar" : "Editar"} banco`}
      </DialogTitle>

      {
        (isLoadingCriarBanco || isLoadingAttBanco) &&
        <Box display="flex" justifyContent="center" mt={4} mb={8}>
          <CircularProgress />
        </Box>
      }

      {
        !isLoadingCriarBanco && !isLoadingAttBanco &&
        <>
          <DialogContent>
          <Box 
          component={'form'}
          onSubmit={handleSubmit(onSubmit)}
          >
            <Grid container spacing={2}>
              <Grid size={{xs: 12}}>

                <ImageWithEditButton<TFormBancos> {...{ imagemPreview, handleChangeInput }} prop="logo_imagem" type='logo'/>
                {errors.logo_imagem && !isEdit &&(
                            <Box color="red" mt={1} textAlign={'center'}>
                                {errors.logo_imagem.message}
                            </Box>
                        )}

                <TextField
                  fullWidth
                  id="outlined-basic"
                  defaultValue={valoresIniciais?.nome}
                  label="Nome"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.nome}
                  helperText={errors.nome ? errors.nome.message : ''}
                  {...register("nome", {
                    required: 'O campo nome é obrigatório',
                    
                  })}
                />
                <TextField
                  fullWidth
                  id="outlined-basic"
                  defaultValue={valoresIniciais?.codigo}
                  label="Código"
                  type="number"
                  variant="outlined"
                  margin="normal"
                  error={!!errors.codigo}
                  helperText={errors.codigo ? errors.codigo.message : ''} 
                  {...register("codigo" , {
                    required: 'O campo código é obrigatório',
                  })} 
                />
              </Grid>
            </Grid>
            <Box mt={2} width={'100%'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} gap={2}>
              <Button
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                type="submit"
                autoFocus
                disabled={ isLoadingCriarBanco || isLoadingAttBanco}
              >
                {
                  (isLoadingCriarBanco || isLoadingAttBanco) &&
                  <CircularProgress size={20} sx={{ marginRight: 1 }} />
                }
                {!isEdit ? "Adicionar" : "Atualizar"}
              </Button>
            </Box>
            </Box>
          </DialogContent>

        </>
      }
    </Dialog>
    </FormProvider>
  )
}

interface DialogCriacaoEditBancosProps {
  open: boolean;
  handleClose: () => void;
  defaultValue: TOpenModal
}
type TFormBancos = {
  nome: string,
  codigo: string,
  logo_imagem: File | null 
}

 

